// @ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import { setModalState, modalViewsConst } from '../../store/modalSlice'
import { checkAssetLimit } from '../../api/stripeSubscription'
import { selectTotalAssetCount } from '../../store/assetsSlice'
import { fetchSubscriptionStatus, selectSubscriptionStatus } from '../../store/userSlice'
import { ReactComponent as GroupIcon } from "../../assets/icons/group-icon.svg";
import { ReactComponent as XClose } from "../../assets/icons/x-close.svg";
import { ReactComponent as HomeSmile } from "../../assets/icons/home-smile.svg";
import { useSelector, useDispatch } from "react-redux";
import PromptArea from "./PromptArea";
import NewAssetModal from "../Modal/NewAssetModal";
import PreviewAsset from "./PreviewAsset";
import PreviewWind from "./PreviewWind";
import ProvisonAssetGroup from "./ProvisonAssetGroup";
import PreviewAndSubmit from "./PreviewAndSubmit";
import LoadingIcon from "../LoadingIcon";
import QSA from "./QSAssetsOverview"
import QSAssetsOverview from "./QSAssetsOverview";
import sampleLLM from "./sampleLLMResponse.json"
import { post } from "aws-amplify/api";
import sampleEndpointResponse from "./sampleEndpointResponse.json"
import { addAssetGroup } from "../../store/assetGroupSlice";
import { addAssetsToDataGroups } from "../../store/assetsSlice";
import { useNavigate } from "react-router-dom";
import { generateClient } from 'aws-amplify/api';
import { v4 as uuidv4 } from 'uuid'
import * as subscriptions from "../../graphql/subscriptions";

const client = generateClient();

const operationStepEnum = {
  firstQuery: "firstQuery",
  pendingItemsOverview: "pendingItemsOverview",
  previewPendingItems: "previewPendingItems",
  reviewPendingItems: "reviewPendingItems",
  submitting: "submitting",
  previewAssets: "previewAssets"
}

function loadSampleLLMWithDelay(delayMs = 5000) {
  return new Promise((resolve) => {
    setTimeout(() => {
      // Resolve with the imported JSON
      resolve(sampleLLM);
    }, delayMs);
  });
}

const QuickSetup = () => {
    // const idRef = useRef(uuidv4()); //fix this later for unique Ids
    const [llmResponse, setLLMResponse] = useState({loaded:false})
    const [operationStep, setOperationStep] = useState(operationStepEnum.firstQuery)
    const [bluePrint, setBluePrint] = useState({}) //this is what is sent to the lambda function to create the assets
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { assetGroups, user, modalState } = useSelector(({ assetGroups, user, modalState }) => ({
      assetGroups,
      user,
      modalState
    }));
    const totalAssetCount = useSelector(selectTotalAssetCount)
    const subscriptionStatus = useSelector(selectSubscriptionStatus)

    // Load the user's subscription (shared Redux cache; the thunk's condition dedupes if another flow already fetched) to enforce the per-tier asset limit.
    useEffect(() => { dispatch(fetchSubscriptionStatus()) }, [dispatch])

    // Open the upgrade modal and return false when creating `assetsToAdd` would exceed the cap.
    // NOTE: no Admin bypass here (unlike Home/GroupPage/useAssetProposalState) — this component is no longer used and is slated for deletion; add the fetchAuthSession + isAdmin guard if it's ever revived.
    const enforceAssetLimit = (assetsToAdd) => {
      // Tier unknown (still loading or fetch failed) — don't block; client-side only for now, backend cap to be added later.
      if (!subscriptionStatus) return true
      const check = checkAssetLimit(subscriptionStatus, totalAssetCount, assetsToAdd)
      if (!check.allowed) {
        dispatch(setModalState({
          modalOpen: true,
          modalView: modalViewsConst.assetLimitReached,
          properties: {
            __modalSize: 'xs',
            tier: check.tier,
            limit: check.limit,
            currentCount: check.currentCount,
            source: 'quick_setup',
          },
        }))
      }
      return check.allowed
    }

    const handleBlueprintUpdate = (blueprintUpdate) => {
      setBluePrint((oldBlueprint) => ({...oldBlueprint, ...blueprintUpdate}))
    }
    
    // Listen for modal results and update blueprint if asset has been modified
    const [prevLastResult, setPrevLastResult] = useState(null);
    
    useEffect(() => {
      // Check if lastResult has changed and is not null
      if (modalState.lastResult && modalState.lastResult !== prevLastResult) {
        // Update previous result reference
        setPrevLastResult(modalState.lastResult);
        
        // Check if this is a result from the NewAssetModal
        if (modalState.lastResult.success && modalState.lastResult.asset && modalState.lastResult.action === 'closeModalWithAssetResult') {
          const { asset } = modalState.lastResult;
          
          // If we have an asset with an ID, update the asset in the blueprint
          if (asset.id && bluePrint.assets && bluePrint.assets[asset.id]) {
            // Update blueprint assets
            setBluePrint(oldBlueprint => {
              // Create a copy of the assets
              const updatedAssets = { ...oldBlueprint.assets };
              
              // Update the specific asset
              updatedAssets[asset.id] =  {
                ...updatedAssets[asset.id],
                ...asset
              }
              
              // Return updated blueprint
              return {
                ...oldBlueprint,
                assets: updatedAssets
              };
            });
            
            console.log('Updated asset in blueprint:', asset.id);
          }
        }
        
        // Check if this is a result from the PerformanceCurveForm
        if (modalState.lastResult.success && modalState.lastResult.windCurve && modalState.lastResult.action === 'onClose') {
          const { windCurve } = modalState.lastResult;
          
          // If we have a wind curve with an ID, update it in the blueprint
          if (windCurve.id && bluePrint.windEnergyModels && bluePrint.windEnergyModels[windCurve.id]) {
            // Update blueprint wind energy models
            setBluePrint(oldBlueprint => {
              // Create a copy of the wind energy models
              const updatedWindModels = { ...oldBlueprint.windEnergyModels };
              
              // Update the specific wind curve
              updatedWindModels[windCurve.id] = {
                ...updatedWindModels[windCurve.id],
                ...windCurve
              };
              
              // Return updated blueprint
              return {
                ...oldBlueprint,
                windEnergyModels: updatedWindModels
              };
            });
            
            console.log('Updated wind curve in blueprint:', windCurve.id);
          }
        }
      }
    }, [modalState.lastResult]);

    useEffect(() => {
      const createSub = client
          .graphql({ 
            query: subscriptions.onCreateLlmResponse,
            // variables: {
            //   id: idRef?.current  //later, if you retry, id is the same!
            // }
          })
          .subscribe({
            next: ({ data }) => {
              try{
                const { onCreateLlmResponse } = data
                console.log("This is the Data subbed",onCreateLlmResponse)
                console.log("onCreateLlmResponseById", onCreateLlmResponse)
                
                // Check if this is an error response (negative executionTime)
                if (!onCreateLlmResponse?.response ||  onCreateLlmResponse?.executionTime < 0) {
                  console.log("Error received from LLM processing")
                  const errorData = JSON.parse(onCreateLlmResponse?.response)
                  
                  // Set error state and display error UI
                  setLLMResponse({
                    loaded: true,
                    error: true,
                    errorMessage: errorData.message || "There was an issue processing your request."
                  })
                  setOperationStep(operationStepEnum.firstQuery) // Return to prompt screen
                  
                  // Show error modal or notification here if you have a global notification system
                  alert(
                    "There was an issue processing your request. The support team has been notified.\n\n" +
                    "Would you like to try again with a different prompt?"
                  )
                  
                  return
                }
                
                // Normal successful response flow
                const parsedAssetGroups = JSON.parse(onCreateLlmResponse?.response)
                console.log("parsedAssetGroups", parsedAssetGroups)
                setLLMResponse(parsedAssetGroups)
                setBluePrint(parsedAssetGroups)
                setOperationStep(operationStepEnum.pendingItemsOverview)
              } catch (e) {
                console.log("Err", e)
                setOperationStep(operationStepEnum.firstQuery)
                alert("There was an error processing the response. Please try again.")
              }
            },
            error: (error) => console.warn(error)
        });

        return () => {
          createSub.unsubscribe();
        };
    }, [])

    const handleSubmitLLM = async (promptData) => {
            // Block before generating if the user is already at their tier's asset cap.
            if (!enforceAssetLimit(1)) return
        // console.log("sampleLLM", sampleLLM)
            // handle data input
            // const output = {
            //     windPowerData: {
            //       name: "sample wind curve2",
            //       description: "test curve",
            //       curveData: [
            //           {
            //               "x": 0,
            //               "y": 0
            //           },
            //           {
            //               "x": 0.3,
            //               "y": 0.35
            //           },
            //           {
            //               "x": 2,
            //               "y": 2.6
            //           },
            //           {
            //               "x": 4,
            //               "y": 9
            //           },
            //           {
            //               "x": 7,
            //               "y": 30
            //           },
            //           {
            //               "x": 9,
            //               "y": 90
            //           },
            //           {
            //               "x": 10,
            //               "y": 90
            //           },
            //           {
            //               "x": 10.5,
            //               "y": 0
            //           }
            //       ],
            //       xUnit: "m/s",
            //       yUnit: "MW",
            //   },
            //     assetGroup: {
            //       name: "Dons WindFarm"
            //     },
            //     asset: {
            //         // assetGroupId:"b7e7aafd-f4a6-4a6b-958a-af79e84ec286",
            //         description: "testAsset2Delete",
            //         elevation: 0,
            //         lat:25,
            //         lng:27,
            //         name: "test",
            //     }
            // }
            console.log("data (Submitted)", { 
              objective:promptData.objective,
              requestId: uuidv4(), //maybe change?
              owner: user?.permissionDetails?.id

            
            })

            try {
                    setOperationStep(operationStepEnum.previewAssets)
                    const restOperation = post({
                      apiName: "crudopsapi",
                      path: "/api/triggerlambda",
                      options: {
                        body: { 
                          objective:promptData.objective,
                          requestId: uuidv4(), //maybe change?
                          owner: user?.permissionDetails?.id

                        
                        },
                      },
                    });
                    // const operationResponse = await restOperation.response;
                    // const { data } = await operationResponse.body.json();

                    // const data = await loadSampleLLMWithDelay(5000);

                    // console.log("data", data)
                    // setLLMResponse(data)
                    // setBluePrint(data)
                    // setOperationStep(operationStepEnum.pendingItemsOverview)
                    
                  } catch (e) {
                    console.log("e", e);
                    setOperationStep(operationStepEnum.firstQuery)
                  }
            // console.log("submit llm", sampleLLM)
            // setLLMResponse(sampleLLM)
            // setBluePrint(sampleLLM)
            // setOperationStep(operationStepEnum.pendingItemsOverview)

        }

    const handleAfterPreview = () => {
      // console.log("Yup", llmResponse)
      // if(llmResponse?.windPowerData) {
      //   setLLMResponse((oldResponse) => ({...llmResponse, step:2 }))
      // }
      // else{
      //   setLLMResponse((oldResponse) => ({...llmResponse, step:3 }))
      // }
      setOperationStep(operationStepEnum.reviewPendingItems)
    }

    // const handleWindPreview = () => {
    //   setLLMResponse((oldResponse) => ({...llmResponse, step:3 }))
    //   setOperationStep(operationStepEnum.submitting)
    // }
    // const handleAssetGroupAdd = (assetGroupName) => {
    //   console.log("assetGroupName", assetGroupName)
    //   setLLMResponse((oldResponse) => ({...llmResponse, step:4 }))
    // }

    // const HandleSubmitQuickSetup = () => {
    //   // console.log("It's done!")
    //   setLLMResponse((oldResponse) => ({...llmResponse, step:5 }))
    // }

    const handleCompleteForm = async () => {
      console.log("llmResponse", llmResponse)
      console.log("blueprint", bluePrint)
      // return
      // Block if creating the proposed assets would push the user over their tier cap.
      const assetsToAdd = Object.keys(bluePrint?.assets || {}).length || 1
      if (!enforceAssetLimit(assetsToAdd)) return
      try {
        
        setOperationStep(operationStepEnum.submitting)
          const restOperation = post({
            apiName: "crudopsapi",
            path: "/api/quickcreate",
            options: {
              body: bluePrint,
            },
          });
          // const operationResponse = await restOperation.response;
          // const { response } = await operationResponse.body.json();
          const operationResponse = await restOperation.response;
          console.log("operationResponse", operationResponse)
          const res = await operationResponse.body.json();
          const { data, sucess } = res
          console.log("{ data, sucess }")
          console.log(data, sucess, res)
          // console.log("sampleEndpointResponse", sampleEndpointResponse)
          const { getAssetGroup } = data
          const assets = [...getAssetGroup?.assets?.items]
          const assetGroup = { ...getAssetGroup}
          delete assetGroup.assets
          console.log("assets", assets)
          console.log("assetGroup", assetGroup)
          dispatch(addAssetGroup(assetGroup))
          dispatch(addAssetsToDataGroups({assetGroupId:assetGroup.id, assets }))
          await delay(2000);
          if (assets.length > 0) {
            navigate(`/home/group/${assetGroup.id}/asset/${assets[0].id}`)
          } else {
            navigate(`/home/group/${assetGroup.id}`)
          }
          
        } catch (e) {
          console.log("e", e)
        }
    }

    function delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
    
    
    // Craig create - go to my assets*
    console.log("Blueprint", bluePrint)

    const renderStepArea = () => {
      switch(operationStep) {
        case operationStepEnum.firstQuery:
          return <PromptArea 
                   onSubmit={handleSubmitLLM}
                   errorMessage={llmResponse.error ? llmResponse.errorMessage : null}
                 />
        case operationStepEnum.pendingItemsOverview:
        return <QSAssetsOverview
                assetGroupList={Object.values(assetGroups?.groups)}
                onCompleteForm={handleCompleteForm}
                llmResponse={bluePrint}
                onAssetGroupChange={handleBlueprintUpdate}
                selectedAssetGroup={bluePrint?.assetGroup?.id}
                onHandlePrevious={()=>setOperationStep(operationStepEnum.firstQuery)}  />
        // return <AssetsOverview onSubmit={handleSubmitLLM} />
        case operationStepEnum.previewPendingItems:
          return <PreviewAsset 
                   onSubmit={handleAfterPreview}
                   onCancel={() => setOperationStep(operationStepEnum.pendingItemsOverview)}
                 />
          // case operationStepEnum.reviewPendingItems:
          //   return <PreviewWind windPowerData={llmResponse.windPowerData} onSubmit={handleWindPreview} />
        case operationStepEnum.submitting:
          return (<div className="flex-1  h-64 justify-center bg-white  p-10 ">
            <LoadingIcon
              borderThick={9}
              logoMult={0.6}
              pixelSize={100}
              fullPage={false}
            />
            <div className="flex justify-center">

              <div className="my-10">Saving assets...</div>
            </div>
          </div>)
        case operationStepEnum.previewAssets:
          return (<div className="flex-1  h-64 justify-center bg-white  p-10 ">
            <LoadingIcon
              borderThick={9}
              logoMult={0.6}
              pixelSize={100}
              fullPage={false}
            />
            <div className="flex justify-center">

              <div className="my-10">Creating Preview...</div>
            </div>
          </div>)
        default:
          return <div>Errpor</div>
      }

      
        // if( .operationStepEnum) {
        //     return <PromptArea onSubmit={handleSubmitLLM} />
        // }
        // else if(llmResponse.step === 1) {
            
        //     return <PreviewAsset onSubmit={handleAfterPreview} /> 
        // }
        // else if(llmResponse.step === 2) {
        //   // Craig next here make smaller preview, copy new asset model
        //   return <PreviewWind windPowerData={llmResponse.windPowerData} onSubmit={handleWindPreview} />   // <PreviewAsset onOk />
        // } else if(llmResponse.step === 3) {
        //   // Craig next here make smaller preview, copy new asset model
          
        //   return <ProvisonAssetGroup onSubmit={handleAssetGroupAdd} />   // <PreviewAsset onOk />
        // } else if(llmResponse.step === 4) {
        //   // Craig next here make smaller preview, copy new asset model
          
        //   return <PreviewAndSubmit bluePrint={completedBluePrint} onSubmit={HandleSubmitQuickSetup} />   // <PreviewAsset onOk />
        // } else if(llmResponse.step === 5) {
        //   // Craig next here make smaller preview, copy new asset model
          
        //   return (<div className="flex-1  h-64 justify-center bg-white  p-10 ">
        //     <LoadingIcon
        //       borderThick={9}
        //       logoMult={0.6}
        //       pixelSize={100}
        //       fullPage={false}
        //     />
        //     <div className="flex justify-center">

        //       <div className="my-10">creating assets...</div>
        //     </div>
        //   </div>)
        // } 
        
    }
    
  return (
    <div className="container mx-auto px-4 py-6">
      <div className="w-full max-w-4xl mx-auto">
        {renderStepArea()}
      </div>
    </div>
  )
}



export default QuickSetup